function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip-Tool_Pentagrama"
}, React.createElement("rect", {
  width: 48,
  height: 48
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Tool_Pentagrama",
  "data-name": "Tool Pentagrama",
  clipPath: "url(#clip-Tool_Pentagrama)"
}, React.createElement("g", {
  id: "Icono",
  transform: "translate(4 4)",
  fill: "none",
  stroke: "#091832",
  strokeWidth: 2
}, React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 9,
  stroke: "none"
}), React.createElement("rect", {
  x: 1,
  y: 1,
  width: 38,
  height: 38,
  rx: 8,
  fill: "none"
})), React.createElement("path", {
  id: "Path_141",
  "data-name": "Path 141",
  d: "M5727.05,1117.992",
  transform: "translate(-5715 -1096)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}), React.createElement("g", {
  id: "noun_Music_1386701",
  transform: "translate(8 8.644)"
}, React.createElement("path", {
  id: "Path_146",
  "data-name": "Path 146",
  d: "M8.54,34.81a2.27,2.27,0,1,0-2.27-2.27A2.27,2.27,0,0,0,8.54,34.81Zm0,2.27a4.54,4.54,0,1,1,4.54-4.54A4.54,4.54,0,0,1,8.54,37.08Z",
  transform: "translate(0 -10.377)",
  fill: "#091832"
}), React.createElement("path", {
  id: "Path_147",
  "data-name": "Path 147",
  d: "M32.54,30.81a2.27,2.27,0,1,0-2.27-2.27A2.27,2.27,0,0,0,32.54,30.81Zm0,2.27a4.54,4.54,0,1,1,4.54-4.54A4.54,4.54,0,0,1,32.54,33.08Z",
  transform: "translate(-10.38 -8.647)",
  fill: "#091832"
}), React.createElement("path", {
  id: "Path_148",
  "data-name": "Path 148",
  d: "M18.27,10.466,29.62,8.845v-2.5l-11.01,1.8a.53.53,0,0,0-.34.395ZM16,8.541a2.764,2.764,0,0,1,2.243-2.635l11.4-1.868a1.866,1.866,0,0,1,2.243,1.9v4.873L16,13.084Z",
  transform: "translate(-5.19)",
  fill: "#091832"
}), React.createElement("path", {
  id: "Path_149",
  "data-name": "Path 149",
  d: "M18.281,26.4V13.8h-2.27V26.4Z",
  transform: "translate(-5.195 -4.233)",
  fill: "#091832"
}), React.createElement("path", {
  id: "Path_150",
  "data-name": "Path 150",
  d: "M42.27,24.647V15H40v9.647Z",
  transform: "translate(-15.57 -4.754)",
  fill: "#091832"
})));

var SvgToolPentagrama = function SvgToolPentagrama(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgToolPentagrama, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Tool Pentagrama.d78b7146.svg";
export { ForwardRef as ReactComponent };